
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

var $957d2f688c216824$exports = {};

(parcelRequire("1hiTA")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"4xsdA\",\"embedCard.936802fc.js\",\"cbF85\",\"component-lazy.a53736cb.js\",\"24IOT\",\"page.3362248d.js\",\"hhss7\",\"vendors~editor_atlaskit_lg.07abb85a.js\",\"ffEVr\",\"vendors~editor_icon.eccba440.js\",\"7k9oy\",\"page.6c082f7e.js\",\"fDgp1\",\"PageNotFoundSVG.5a354fce.svg\",\"bTkQa\",\"LoginPageIconSVG.f5d1b132.svg\",\"gnvnd\",\"ConnectLoomToConfluenceSVG.8db7b17b.svg\",\"9TOep\",\"vendors~editor_atlaskit_sm.8a057295.js\",\"bm0AN\",\"page.cc81b11c.js\",\"6wr18\",\"vendors~editor_icon.d3a3610c.js\",\"aqs28\",\"page.e26ce211.js\",\"6bjEk\",\"component-lazy.a60e7c80.js\",\"hLbGw\",\"audio-icon.61ce137c.js\",\"gkVge\",\"16.f2f809f8.js\",\"kDfOJ\",\"angle-brackets-icon.3cf5fa5d.js\",\"iN2uJ\",\"folder-icon.2317bd67.js\",\"6aZeI\",\"image-icon.4a16de27.js\",\"8TGE7\",\"video-icon.07fdb52c.js\",\"5JWJI\",\"16.afb726c6.js\",\"aQ5uu\",\"16.cca36010.js\",\"geXPZ\",\"16.cb90449c.js\",\"b4nm1\",\"16.56ac2164.js\",\"jfYeU\",\"16.17ff82d7.js\",\"kYkz1\",\"16.a6384ea5.js\",\"5kI0b\",\"16.dab24e6f.js\",\"3i44s\",\"16.e289cc83.js\",\"4QwAJ\",\"16.fcb02685.js\",\"fHlIz\",\"16.b690aa43.js\",\"aaRXj\",\"16.c0de4382.js\",\"6OMo6\",\"16.2c4333b0.js\",\"aFLSJ\",\"branch.46e77f03.js\",\"4N1MY\",\"bug.c60fff0f.js\",\"il8bj\",\"changes.3f689b5c.js\",\"kG5Ju\",\"code.444e178b.js\",\"3Cky6\",\"commit.4f82e0b6.js\",\"aIze1\",\"epic.5256aac3.js\",\"7rqWx\",\"incident.b7ba1365.js\",\"jw3lv\",\"problem.5c545c5c.js\",\"39XCn\",\"pull-request.a1d6e247.js\",\"jXM1T\",\"story.a609ccd8.js\",\"4zz48\",\"subtask.3d296e24.js\",\"iZR3N\",\"task.d7240f81.js\",\"cvcNg\",\"work-item.7f9db6c3.js\",\"7m6JR\",\"component-lazy.5f371caf.js\",\"1pJPT\",\"file-icon.89626542.js\",\"duEFL\",\"chart-bar-icon.5974ee28.js\",\"6fJCf\",\"list-bullet-icon.81a23beb.js\",\"hLB9K\",\"embedCard.8971fa79.js\",\"bJbqV\",\"embedCard.runtime.ac2244d8.js\",\"lIiD7\",\"component-lazy.d44f49cb.js\",\"kfGHh\",\"component-lazy.runtime.65259544.js\",\"45r7q\",\"get-custom-theme-styles.b5149ade.js\",\"bJbqV\",\"embedCard.runtime.ac2244d8.js\",\"kfGHh\",\"component-lazy.runtime.65259544.js\",\"9zzZg\",\"manual-triggers-modal.581abac2.js\",\"7EorR\",\"vendors~editor_atlaskit_md.6853fd01.js\",\"bSSct\",\"SpaceTargetSelect.d01ead66.js\",\"iWnyc\",\"manual-triggers-modal.dd67e8df.js\",\"kHXvF\",\"manual-triggers-modal.48402b91.js\",\"hTwYJ\",\"goal-icon.2b3013a6.js\",\"9PVXs\",\"projects-icon.47c4b8f9.js\",\"ikMj1\",\"RelatedLinksModal.f6423ecb.js\",\"jrGyY\",\"priority-icons.778b47e8.js\",\"c4Al8\",\"priority-blocker.984979f9.js\",\"dtb6I\",\"priority-critical.0b51b93f.js\",\"exCSw\",\"priority-high.678e6a2d.js\",\"02Zp4\",\"priority-highest.065becc4.js\",\"d7uYo\",\"priority-low.cacd9169.js\",\"jQMSx\",\"priority-lowest.ddd543d3.js\",\"4J6Or\",\"priority-major.042467a2.js\",\"d6ClG\",\"priority-medium.4690d482.js\",\"fzYHf\",\"priority-minor.be4fa880.js\",\"iehPx\",\"priority-trivial.03be75c0.js\",\"kGKln\",\"audio-icon.6f385043.js\",\"bAe4U\",\"angle-brackets-icon.bc4e4000.js\",\"bsuUF\",\"folder-icon.24b6e2bf.js\",\"g36gj\",\"image-icon.af04a4c9.js\",\"14QdI\",\"video-icon.553e2c46.js\",\"9ZAcQ\",\"component.892cd1f2.js\"]"));


$parcel$global.rlb("le1z7")
//# sourceMappingURL=embedCard.runtime.e743c2af.js.map
